<template>
  <AtomsLabel
    class="relative cursor-pointer before:absolute before:top-0.5 before:block before:h-4 before:w-4 before:border after:absolute after:left-[5px] after:top-[5px] after:block after:h-2 after:w-1.5 after:rotate-45 after:border-b after:border-r after:transition-all"
    :class="[colorClass, { 'after:opacity-0': !checked }]"
  >
    <input :id="props.id" class="hidden" type="checkbox" :checked="checked" :data-testid="props.dataTestId" :disabled="props.disabled" @change="updateValue" @click.stop />
    <span class="relative top-[-1px] ml-5">
      <slot />
    </span>
  </AtomsLabel>
</template>

<script setup lang="ts">
interface Props {
  modelValue: boolean;
  id: string;
  disabled?: boolean;
  dataTestId?: string;
  color?: 'gray' | 'gold' | 'light-fg-inverse';
}

const props = withDefaults(defineProps<Props>(), { disabled: false, dataTestId: '', color: 'gray' });

const checked = computed(() => props.modelValue);

const colorClass = computed(() => {
  switch (props.color) {
    case 'gray':
      return 'before:border-gray2 after:border-black1';
    case 'gold': {
      const commonStyle = 'before:border-gold1 after:border-white';
      return checked.value ? `${commonStyle} before:bg-gold1` : commonStyle;
    }
    case 'light-fg-inverse':
      return 'before:border-light-fg-inverser after:border-light-fg-inverse';
  }
});

interface Emits {
  (event: 'update:modelValue', value: boolean): void;
}

const emits = defineEmits<Emits>();

const updateValue = (e: Event) => {
  emits('update:modelValue', (e.target as HTMLInputElement).checked);
};
</script>
